// ABOUTME: Custom error classes for PhotoStream API client
// ABOUTME: Provides typed error handling with HTTP status codes and messages

export class PhotoStreamApiError extends Error {
  constructor(
    public statusCode: number,
    message: string,
    public response?: any
  ) {
    super(message);
    this.name = 'PhotoStreamApiError';
  }
}

export class NetworkError extends Error {
  constructor(message: string, public originalError?: Error) {
    super(message);
    this.name = 'NetworkError';
  }
}
